import React, { useState, useEffect } from "react";
import ReactPlayer from 'react-player/lazy';
import '../App.css';

function VideoAds({video,onDurationChange}) {
  const [fade,setFade]=useState(false);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (duration) {
      const timeoutId = setTimeout(() => {
        setFade(true);
      }, 120000);
  
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [duration]);

  const handleLoadedMetadata = (duration) => {
    setDuration(duration);
    if (onDurationChange) {
      onDurationChange(duration);  
    }
  };

  return (
      <div
      className={`content-box ${fade ? 'fade-out' : ''}`}
      // style={{width:"100vw",height:"100vh",objectFit:"cover",}}
      >
        <ReactPlayer
          width="100vw"
          height="100vh"
          playsinline={true}
          className="profile-img"
          playing={true}
          autoPlay
          loop={true}
          controls={false}
          muted={true}
          url={video}
          onDuration={handleLoadedMetadata}
        />
      </div>
  )
}

export default VideoAds;
